import revive_payload_client_4sVQNw7RlN from "/var/www/homedelimercado.com/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/homedelimercado.com/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/homedelimercado.com/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/www/homedelimercado.com/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/www/homedelimercado.com/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/homedelimercado.com/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/homedelimercado.com/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/var/www/homedelimercado.com/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/var/www/homedelimercado.com/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/homedelimercado.com/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_UYiXMU8ZyN from "/var/www/homedelimercado.com/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import plugin_vfCt6Q18Tc from "/var/www/homedelimercado.com/node_modules/nuxt-auth-sanctum/dist/runtime/plugin.js";
import anchorscroll_plugin_PcZY5oWLsO from "/var/www/homedelimercado.com/node_modules/nuxt-anchorscroll/dist/runtime/anchorscroll-plugin.js";
import plugin_sb2LSEEy8f from "/var/www/homedelimercado.com/node_modules/nuxt-quasar-ui/dist/runtime/plugin.js";
import switch_locale_path_ssr_5csfIgkrBP from "/var/www/homedelimercado.com/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/var/www/homedelimercado.com/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import chartjs_1wC9lAM0Tp from "/var/www/homedelimercado.com/plugins/chartjs.ts";
import i18n_VfGcjrvSkj from "/var/www/homedelimercado.com/plugins/i18n.ts";
import mitt_client_JdecFmZkyR from "/var/www/homedelimercado.com/plugins/mitt.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_UYiXMU8ZyN,
  plugin_vfCt6Q18Tc,
  anchorscroll_plugin_PcZY5oWLsO,
  plugin_sb2LSEEy8f,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  chartjs_1wC9lAM0Tp,
  i18n_VfGcjrvSkj,
  mitt_client_JdecFmZkyR
]